import React, { useEffect, useState } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom'
import SearchBar from '../../../Components/Utils/SearchBar'
import { ClearFilterButton, CreateButton, ExportButton, FilterButton, ImportButton } from '../../../Components/Utils/Buttons'
import { GetAccess } from '../../../Components/Utils/roles'
import Breadcrumb from '../../../Components/Utils/Breadcrumb'
import NuAmount from '../../../Components/Utils/NuAmount'

const InvoiceLayout = (
    {
        getData=() => {},
        setSearchQuery=()=>{},
        CreateAccess= false,
        ImportAccess= false,
        setOpen=()=>{},
        children,
        onCreateClick,
        searchValue="",
        searchFun=()=>{},
        isFilter=false,
        setFilterOpen=()=>{},
        newfilter=false,
        ClearFilter=()=>{},
        neededSearch=false,
        showproject=true,
        isCard=true,
        setViewMode=()=>{},
            viewMode="",
            ExportAccess=false,
        setOpenExport=()=>{},
                total={total},
                total_amount={total_amount},
                page_amount={page_amount},
                due_amount={due_amount},


    }
) => {
    let {pathname} = useLocation()
    let {officeId,projecTId} = useParams()
    
    const [module,setModule] = useState("")
    
    useEffect(() =>{
         if(pathname == `/invoice/invoice-outgoing`){
            setModule("Outgoing")
        }
        else{
            setModule("Invalid")
        }
    },[pathname])

    let LinkItem = [
       
       
        {
            label:"Invoice",
            link:`/invoice/invoice-outgoing`,
            access:GetAccess("invoice_out_view"),
        },
       
       
          ]
    
    return(
        <div className=" w-full  h-full pt-2 px-4 overflow-hidden">
            <div className="">
            <div className="md:flex justify-between w-full ">
             <Breadcrumb
                              items={[
                                { name: "Invoice" },
                               
                    
                                { name: module },
                              ]}
                            />

            
           

            <div className=" flex justify-end items-center gap-3 ">
            <form className="flex items-center gap-3 mx-0" onSubmit={getData}>
            <SearchBar handleChange={searchFun}  value={searchValue}/>

            </form>
              <FilterButton label='Filter'  handleClick={()=>{setFilterOpen(true);setSearchQuery("");}} />
              {isFilter&& <ClearFilterButton label='Clear'  handleClick={ClearFilter} />} 
               {ImportAccess && <ImportButton label="Import" handleClick={()=>setOpen(true)}    />}
                               {ExportAccess && <ExportButton label="Export" handleClick={()=>setOpenExport(true)}    />}
                

              {CreateAccess && <Link to={`${pathname}/create`}><CreateButton label="Add"/></Link>}
                  {/* <BackButton/> */}
                </div>
            </div>

           <div className="w-full overflow-x-auto whitespace-nowrap scrollbar-hide md:flex  gap-x-10 mt-0.5">
        <div className="inline-flex items-center gap-x-1">
      {
                LinkItem && LinkItem.map((item, i) => {
      const isActive = item?.link === pathname;

                    return(
                        <>
                         {
                            item.access && (

                                <Link
                                                                                               to={item?.link}
                                                                                               key={item?.link}
                                                                                               className={`px-4 py-1 rounded-t-md text-xs 2xl:text-sm font-medium mt-0.5
                                                                                                 ${isActive 
                                                                                                   ? "bg-baseColor-primary text-white" 
                                                                                                   : "bg-white text-baseColor-primary border-b-2 border-baseColor-primary"
                                                                                                 }`}
                                                                                             >
                                                                                               {item?.label || ""} 
                                                                                             </Link>
                                                    // <Link to={item?.link} className={`mx-3 pb-1 text-xs 2xl:text-sm font-medium text-baseColor-primary ${item?.link == pathname ?"border-b-2 border-baseColor-primary":"border-b-2 border-transparent"}   `}  key={item?.link} >{item?.label||""}</Link>
                                // <Link to={item?.link} className={`mx-3 pb-1 text-xs 2xl:text-sm font-medium text-baseColor-primary ${item?.link == pathname ?"border-b-2 border-baseColor-primary":"border-b-2 border-transparent"}   `}  key={item?.link} >{item?.label||""}</Link>

                                     )
                         }
                        </>
                    )
                })
            }
        </div>
       <div className="">
  <div className="sm:mt-0 mt-1 h-auto border rounded-full mr-3 border-baseColor-primary text-xs inline-flex w-auto flex-shrink-0 justify-center overflow-hidden">
    <p className=" w-auto bg-white text-black px-2 flex items-center justify-center">Count</p>
    <p className="bg-baseColor-primary w-auto  text-white px-2 flex items-center justify-center">
      {total || "0"}
    </p>
  </div>

  <div className="sm:mt-0 mt-1 h-6 border rounded-full mr-3 border-green-600 text-xs inline-flex w-auto flex-shrink-0 justify-center overflow-hidden">
    <p className=" bg-white text-black px-2 flex items-center justify-center">Total Amt</p>
    <p className="bg-green-600 text-white px-2 flex items-center justify-center">
     
      <NuAmount  value={total_amount}/>
    </p>
  </div>

  <div className="sm:mt-0 mt-1 h-6 border rounded-full mr-3 border-yellow-600 text-xs inline-flex w-auto flex-shrink-0 justify-center overflow-hidden">
    <p className=" bg-white text-black px-2 flex items-center justify-center">Page Amt</p>
    <p className="bg-yellow-600  text-white px-2 flex items-center justify-center">
            <NuAmount  value={page_amount}/>

    </p>
  </div>

  <div className="sm:mt-0 mt-1 h-6 border rounded-full mr-3 border-blue-600 text-xs inline-flex w-auto flex-shrink-0 justify-center overflow-hidden">
    <p className=" bg-white text-black px-2 flex items-center justify-center">Due Amt</p>
    <p className="bg-blue-600  text-white px-2 flex items-center justify-center">
            <NuAmount  value={due_amount}/>

    </p>
  </div>
</div>

    </div>
            
            <div className=" w-full h-[calc(100vh-203px)] md:h-[calc(100vh-165px)]   ">
               {children} 
            </div>
            </div>
        </div>
    )
}

export default InvoiceLayout
